import apiClient from '@/plugins/axios';

export default {
	getRounds(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/Round${query}`);
	},

	getRound(roundId) {
		return apiClient.get(`v1/Round/${roundId}`);
	},

	createRound(round) {
		return apiClient.post('v1/Round', round);
	},

	updateRound(round) {
		var roundId = round.id;

		return apiClient.put(`v1/Round/${roundId}`, round);
	},

	deleteRound(roundId) {
		return apiClient.delete(`v1/Round/${roundId}`);
	}
};
